import React, { useEffect, useState, useRef } from 'react';
import * as io from 'socket.io-client';
import UseToast from '../UseToast';
import { UseTranslationData, getRandomMessage } from '../UseTranslationData';

const sampleRate = 16000;

const getMediaStream = () =>
  navigator.mediaDevices.getUserMedia({
    audio: {
      deviceId: 'default',
      sampleRate: sampleRate,
      sampleSize: 16,
      channelCount: 1,
    },
    video: false,
  });

const AudioToText = ({
  siteBrandColor,
  onstartConverting,
  onstopRecording,
  translationData,
  aiFormData,
  onplayPromoMessage,
  onsessionInfo,
  // onSpeechRecognitionEnd,
  onstartspeech,
  rizwanScriptStep,
  setonstartspeech,
  rizwanScriptStepEnglishRef,
  rizwanButtonFun,
  onfaceDetectionStartSpeech,
  setfaceDetectionStartSpeech,
  isInRangeRefFun,
  onplayUserSilenceMsg,
  playRandomSpeech,
  idealMode,
  resetLoopVideoBtnCase,
  waitingTime,
  disableSpeechButton,
  startAutoButtonSpeech,
  setStartAutoButtonSpeech
}) => {


  const [connection, setConnection] = useState(null);
  const [currentRecognition, setCurrentRecognition] = useState('');
  const [currentRecognitionLang, setCurrentRecognitionLang] = useState('');
  const [userSilent, setUserSilent] = useState(false);
  const [audioPaused, setAudioPaused] = useState(false);

  const [recognitionHistory, setRecognitionHistory] = useState([]);
  const [isRecording, setIsRecording] = useState(false);
  const processorRef = useRef(null);
  const audioContextRef = useRef(null);
  const audioInputRef = useRef(null);
  const recordingTimeoutRef = useRef(null); // Timer for auto-stop after 10 seconds
  const inactivityTimer = useRef(null); // Timer for inactivity
  const silenceTimer = useRef(null); // Timer for silence
  const onsessionInfoRef = useRef(onsessionInfo);
  const rizwanScriptStepRef = useRef(rizwanScriptStep);

  const detectIsFinal = useRef(false);

  const isUserSilent = useRef(false);

  const isAudioPaused = useRef(false);

  const inactivityTimeLimit = aiFormData?.promo_time_limit; // Default to 10 seconds
  const blankSpaceTime = aiFormData?.blank_space; // Default to 5 seconds

  const currentRecognitionRef = useRef('');
  const currentRecognitionLangRef = useRef('');
  const currentRecognitionLangListenRef = useRef('');
  const [disabledState, setDisabledState] = useState(disableSpeechButton);
  const [autoStart, setAutoStart] = useState(false);

  const { showSuccessToast, dismissToast } = UseToast(); // Use the custom hook

  const [audioDataFinal, setAudioDataFinal] = useState({});

  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const words =
    "Welcome! I've let Amy know you are here. Is there anything else I can help you with?".split(
      ' '
    );
  const timerRef = useRef(null);

  const [showStartButton, setShowStartButton] = useState(true);

  const [clickSound, setClickSound] = useState(null); // State to hold the audio object


  const [hasSessionStarted, setHasSessionStarted] = useState(false);



  useEffect(() => {
    // Preload the audio sound
    const audioUrl = aiFormData?.click_sound_audio;
    if (audioUrl) {
      const audio = new Audio(audioUrl);
      const volume = aiFormData?.click_sound_volume || 1; // Get volume from props
      audio.volume = volume; // Set the volume
      audio.load(); // Preload the audio
      setClickSound(audio);
    }
  }, [aiFormData?.click_sound_audio, aiFormData?.click_sound_volume]);

  useEffect(() => {
    isUserSilent.current = userSilent;
  }, [userSilent]);

  useEffect(() => {
    setDisabledState(disableSpeechButton);
  }, [disableSpeechButton]);

  useEffect(() => {
    setAutoStart(startAutoButtonSpeech);
  }, [startAutoButtonSpeech]);

  useEffect(() => {
    if (rizwanScriptStepEnglishRef) {
      setCurrentWordIndex(0); // Reset word index when it becomes true
      timerRef.current = setInterval(() => {
        setCurrentWordIndex(prevIndex => prevIndex + 1);
      }, 380); // Adjust the speed here (500ms = 0.5 second per word)
    } else {
      clearInterval(timerRef.current);
    }

    return () => {
      clearInterval(timerRef.current); // Clean up on unmount
    };
  }, [rizwanScriptStepEnglishRef]);

  useEffect(() => {
    setCurrentText(words.slice(0, currentWordIndex).join(' '));
  }, [currentWordIndex]);

  useEffect(() => {
    rizwanScriptStepRef.current = rizwanScriptStep;
  }, [rizwanScriptStep]);

  useEffect(() => {
    detectIsFinal.current = audioDataFinal?.isFinal ? true : false;
  }, [audioDataFinal]);

  useEffect(() => {
    currentRecognitionRef.current = currentRecognition;
  }, [currentRecognition]);

  useEffect(() => {
    currentRecognitionLangRef.current = currentRecognitionLang;
    let listenWord;
    listenWord = UseTranslationData(aiFormData, currentRecognitionLang.split('-')[0]);

    currentRecognitionLangListenRef.current = listenWord?.listening_text;

    // buttonTextMessage()

  }, [currentRecognitionLang, disabledState]);

  const buttonTextMessage = () => {
    let listenWord;
    listenWord = UseTranslationData(aiFormData, currentRecognitionLang.split('-')[0]);
    if (aiFormData?.isButtonSelectMsgOn && listenWord?.button_select_message) {

      currentRecognitionLangListenRef.current = getRandomMessage(listenWord?.button_select_message || 'Listening...');
    } else {
      currentRecognitionLangListenRef.current = listenWord?.listening_text;
    }


  }

  useEffect(() => {
    if (onsessionInfo) {
      setHasSessionStarted(true);
    }

    onsessionInfoRef.current = onsessionInfo;
  }, [onsessionInfo]);



  useEffect(() => {
    isAudioPaused.current = audioPaused;
  }, [audioPaused]);

  useEffect(() => {
    // console.log("isInRangeRefFun",isInRangeRefFun)

    if (onfaceDetectionStartSpeech && isInRangeRefFun) {
      setAudioPaused(false);

      const ai_starttalk = document.getElementById('ai_starttalk');
      if (ai_starttalk) {
        ai_starttalk.click();
      }

      //connect();
      setUserSilent(false);
    }
  }, [onfaceDetectionStartSpeech]);


  useEffect(() => {

    if (autoStart && !idealMode && aiFormData?.enable_face_detection !== 'yes' && aiFormData?.enable_voice_detection !== 'yes') {
      const ai_starttalk = document.getElementById('ai_starttalk');
      if (ai_starttalk) {
        ai_starttalk.click();
      }

      if (aiFormData?.enable_auto_speech_response && showStartButton && !idealMode) {
        // Hide start button after first click
        setShowStartButton(false);
      }
    }
  }, [autoStart]);






  const playPromoMessage = () => {
    disconnect(); // Stop the recording
    onplayPromoMessage(onsessionInfoRef.current);
    resetInactivityTimer();
  };

  const resetInactivityTimer = () => {
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }
    if (inactivityTimeLimit && inactivityTimeLimit > 0) {
      inactivityTimer.current = setTimeout(
        playPromoMessage,
        inactivityTimeLimit * 60 * 1000 // Convert to milliseconds
      );
    }
  };

  const resetSilenceTimer = () => {
    // Don't start silence timer when using voice detection
    // Voice detection handles the conversation flow entirely
    if (aiFormData?.enable_voice_detection === 'yes') {
      console.log('Voice detection active - skipping silence timer');
      return;
    }
    
    if (aiFormData.enable_rizwan_event !== 'yes') {
      recordingTimeoutRef.current = setTimeout(() => {
        playUserSilenceMessage();
      }, aiFormData.speech_time_limit * 1000);
    }
  };

  const playUserSilenceMessage = () => {
    if (aiFormData.enable_rizwan_event !== 'yes' && !isUserSilent.current) {
      onplayUserSilenceMsg(onsessionInfoRef.current);

      if (aiFormData?.enable_auto_speech_response) {
        setStartAutoButtonSpeech();
        setShowStartButton(true);
      }



      if (aiFormData.enable_face_detection === 'yes') {
        setfaceDetectionStartSpeech();
      }
    }

    // Manually trigger the button click
    const stopRecordingButton = document.getElementById('stoprecording');
    if (stopRecordingButton) {
      stopRecordingButton.click();
    }
  };

  const stopRecordingDueToSilence = () => {
    console.log('Silence detected. Stopping the recording...');
    
    // Check if session is still active before processing
    if (!onsessionInfoRef.current) {
      console.log('No active session - skipping silence processing');
      disconnect();
      return;
    }
    
    const finalRecognition = currentRecognitionRef.current; // Accessing the current recognition value from the ref

    const finalRecognitionLang = currentRecognitionLangRef.current;

    console.log('finalRecognitionLang', finalRecognitionLang); // This should now log the correct value

    if (finalRecognition) {
      // Clear the silence timer since user spoke successfully
      if (recordingTimeoutRef.current) {
        clearTimeout(recordingTimeoutRef.current);
        recordingTimeoutRef.current = null;
      }
      
      onstopRecording(finalRecognition, finalRecognitionLang.split('-')[0], finalRecognitionLang);
      if (aiFormData.enable_rizwan_event === 'yes') {
        currentRecognitionRef.current = '';
        setCurrentRecognition('');
        setonstartspeech();
      }

      if (aiFormData?.enable_auto_speech_response) {
        setStartAutoButtonSpeech();
      }

      if (aiFormData.enable_face_detection === 'yes' && aiFormData.enable_rizwan_event !== 'yes') {
        setfaceDetectionStartSpeech();
      }

      setAudioPaused(true);

      // Manually trigger the button click
      const stopRecordingButton = document.getElementById('stoprecording');
      if (stopRecordingButton) {
        stopRecordingButton.click();
      }

      //setCurrentRecognition("");

      // disconnect();
    }
  };

  const stringConversion = searchText => {
    // Safely get individual replacements from translationData
    const textArray =
      translationData?.text_replace?.split('\n')?.filter(item => item.trim() !== '') || [];

    // Split the search text into words
    const wordsToSearch = searchText.split(/\s+/);

    console.log('Original wordsToSearch', wordsToSearch);

    // Function to normalize words
    const normalizeWord = word => word.replace(/[^\w\s]/gi, '').toLowerCase();

    // Update each word in the search text if it matches any translationData replacements
    const updatedText = wordsToSearch
      .map(word => {
        const normalizedWord = normalizeWord(word);

        // Only proceed if textArray exists and has items
        if (textArray && textArray.length > 0) {
          for (let item of textArray) {
            const [lhs, rhs] = item.split('|').map(part => part.trim());
            const normalizedLHS = normalizeWord(lhs);

            if (normalizedLHS === normalizedWord) {
              return rhs;
            }
          }
        }
        return word; // Return unchanged word if no match found
      })
      .join(' ');

    console.log('Updated Text', updatedText);
    return updatedText;
  };

  const speechRecognized = data => {
    if (data.isFinal) {
      let uptext = stringConversion(data.text);
      setCurrentRecognition(uptext);
      currentRecognitionRef.current = uptext;
      setRecognitionHistory(old => [data.text, ...old]);
      setCurrentRecognitionLang(data.languageCode[0]);

      const totalTextWordCount = uptext.split(/\s+/).length;

      if (totalTextWordCount <= 2 && aiFormData?.isTwoWordsEnabled) {
        playRandomSpeech(onsessionInfoRef.current);

        if (aiFormData?.enable_auto_speech_response) {
          setStartAutoButtonSpeech();
        }

        if (aiFormData.enable_face_detection === 'yes') {
          setfaceDetectionStartSpeech();
        }

        // Manually trigger the button click
        const stopRecordingButton = document.getElementById('stoprecording');
        if (stopRecordingButton) {
          stopRecordingButton.click();
        }
      } else {
        stopRecordingDueToSilence();
      }
    } else {
      //setCurrentRecognition(uptext);

      setCurrentRecognitionLang(data.languageCode[0]);
      //detectIsFinal.current=false;
      // setAudioDataFinal({});
    }

    // if (recordingTimeoutRef.current) {
    //     clearTimeout(recordingTimeoutRef.current);
    //     }
    resetInactivityTimer(); // Reset inactivity timer whenever speech is detected
    if (recordingTimeoutRef.current) {
      clearTimeout(recordingTimeoutRef.current);
    }
  };

  // On Click start

  const connect = () => {
    if (aiFormData?.enable_face_detection !== 'yes' && idealMode) {
      resetLoopVideoBtnCase();
      return;
    }

    if (connection) connection.disconnect();


    //  setDisabledState(true);

    try {
      // const socket = io.connect('https://sandbox.holomedia.ai');

      const socket = io.connect("https://aih.holomedia.ai");

      socket.on('connect', () => {
        console.log('connected', socket.id);

        // currentRecognitionLangListenRef.current = '';
        if (aiFormData.enable_rizwan_event === 'yes') {
          showSuccessToast('Please Speak Now!');
        }

        if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection === 'yes') {
          showSuccessToast('Please Speak Now!');
        }

        // if (autoStart && aiFormData?.enable_auto_speech_response) {
        //   showSuccessToast('Please Speak Now!');

        // }



        setConnection(socket);
        onstartConverting(onsessionInfo);

        const data = {
          sessionInfo: onsessionInfoRef.current,
          rizwanScriptStep: rizwanScriptStepRef.current,
          rizwanStatus: aiFormData.enable_rizwan_event === 'yes' ? true : false || false,
        };
        socket.emit('startGoogleCloudStream', data);
      });

      socket.on('receive_audio_text', data => {
        console.log('received audio text', data);
        speechRecognized(data);
        setUserSilent(true);
      });

      socket.on('disconnect', () => {
        console.log('disconnected', socket.id);
      });

      socket.on('connect_error', (error) => {
        console.error('Connection error:', error);
        alert('Failed to connect to speech recognition service. Please try again.');
      });

      socket.on('error', (error) => {
        console.error('Socket error:', error);
        alert('Speech recognition service error. Please try again.');
      });

    } catch (error) {
      console.error('Error connecting to socket:', error);
      alert('Failed to initialize speech recognition. Please check your connection.');
    }
  };


  const disconnect = () => {
    //console.log("!isUserSilent.current",isUserSilent.current)

    if (aiFormData.enable_rizwan_event !== 'yes' && aiFormData.enable_face_detection !== 'yes') {
      document.getElementById('ai_starttalk').style.display =
        aiFormData?.enable_auto_speech_response && !showStartButton ? 'none' : 'flex';
      document.getElementById('stoprecording').style.display = 'none';
    }

    if (!connection) return;

    connection.emit('endGoogleCloudStream');
    connection.disconnect();
    processorRef.current?.disconnect();
    audioInputRef.current?.disconnect();
    audioContextRef.current?.close();
    setConnection(null);
    setIsRecording(false);

    dismissToast();

    // Clear ALL timers when disconnecting
    if (recordingTimeoutRef.current) {
      clearTimeout(recordingTimeoutRef.current);
      recordingTimeoutRef.current = null;
    }
    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
      inactivityTimer.current = null;
    }
    if (silenceTimer.current) {
      clearTimeout(silenceTimer.current);
      silenceTimer.current = null;
    }
    
    // restore disabled state to follow parent prop after disconnect
    setDisabledState(disableSpeechButton);
  };

  useEffect(() => {
    resetInactivityTimer(); // Start inactivity timer when component mounts

    return () => {
      if (isRecording) {
        processorRef.current?.disconnect();
        audioInputRef.current?.disconnect();
        if (audioContextRef.current?.state !== 'closed') {
          audioContextRef.current?.close();
        }
      }
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
      if (silenceTimer.current) {
        clearTimeout(silenceTimer.current);
      }
    };
  }, [isRecording]);

  useEffect(() => {
    (async () => {
      if (connection && !isRecording) {
        const stream = await getMediaStream();

        audioContextRef.current = new window.AudioContext();

        await audioContextRef.current.audioWorklet.addModule(
          '/src/worklets/recorderWorkletProcessor.js'
        );

        audioContextRef.current.resume();

        audioInputRef.current = audioContextRef.current.createMediaStreamSource(stream);

        processorRef.current = new AudioWorkletNode(audioContextRef.current, 'recorder.worklet');

        processorRef.current.connect(audioContextRef.current.destination);
        audioContextRef.current.resume();

        audioInputRef.current.connect(processorRef.current);

        processorRef.current.port.onmessage = event => {
          const audioData = event.data;
          connection.emit('send_audio_data', { audio: audioData });
        };

        setIsRecording(true);

        if (aiFormData.enable_rizwan_event !== 'yes') {
          console.error('No repe');

          // Automatically stop recording after 10 seconds
          // recordingTimeoutRef.current = setTimeout(() => {
          //   disconnect();
          // }, aiFormData.speech_time_limit*1000);
        }

        resetInactivityTimer(); // Start inactivity timer when recording starts
        resetSilenceTimer(); // Start silence timer when recording starts
      } else {
        console.error('No connection');
      }
    })();
    return () => {
      if (isRecording) {
        processorRef.current?.disconnect();
        audioInputRef.current?.disconnect();
        if (audioContextRef.current?.state !== 'closed') {
          audioContextRef.current?.close();
        }
      }
    };
  }, [connection, isRecording]);

  // const playSound = () => {
  //   const audioUrl = aiFormData?.click_sound_audio;
  //   const volume = aiFormData?.click_sound_volume || 1;
  //   if (audioUrl && showStartButton && aiFormData?.enable_face_detection !== 'yes') {
  //     const audio = new Audio(audioUrl);
  //     audio.volume = volume || 1;

  //     audio.play().catch(error => {
  //       console.error('Audio playback failed:', error);

  //     });
  //   }
  // };

  const playSound = () => {
    if (clickSound && showStartButton && aiFormData?.enable_face_detection !== 'yes') {
      clickSound.currentTime = 0; // Reset to the start
      clickSound.play().catch(error => {
        console.error('Audio playback failed:', error);
      });
    }
  };


  useEffect(() => {
    if (idealMode) {
      setShowStartButton(true);
    }
  }, [idealMode]);


  return (
    <div>
      {aiFormData?.enable_speech_btn === 'yes' && (
        <>
          <button
            type="button"
            className="ai_starttalk"
            id="ai_starttalk"
            // style={{
            //   backgroundColor: disableSpeechButtonRef.current ? 'lightgrey': siteBrandColor,
            //   display:
            //     aiFormData.enable_rizwan_event === 'yes' ||
            //       aiFormData.enable_face_detection === 'yes'
            //       ? 'none'
            //       : '',
            //   opacity: disableSpeechButtonRef.current ? 0.6 : 1,
            // }}
            style={{
              backgroundColor: disabledState ? 'gray' : siteBrandColor,
              display:
                (aiFormData.enable_face_detection === 'yes' || !showStartButton)
                  ? 'none'
                  : 'flex',
              opacity: disabledState ? 0.7 : 1,
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1vw',
            }}
            onClick={(e) => {

              if (disabledState && e?.isTrusted) return;

              setAudioPaused(false);
              playSound();
              connect();
              setUserSilent(false);
            }}
          // disabled={disabledState}
          >
            {/* {waitingTime || !onsessionInfoRef.current
              ? translationData?.avatar_before_loading_text || 'Please Wait...'
              : translationData?.ask_your_question} 
            <span>{waitingTime || !onsessionInfoRef.current
              ? translationData?.avatar_before_loading_text || 'Please Wait...'
              : translationData?.ask_your_question}
            </span>

            {!waitingTime && onsessionInfoRef.current &&
              <div><img src="/vendors/images/microphone-V2.png" alt="" style={{ width: "2.5vw" }} /></div>
            }
              */}


            <span>{((waitingTime || (!onsessionInfoRef.current && !hasSessionStarted)) && !idealMode)
              ? translationData?.avatar_before_loading_text || 'Please Wait...'
              : translationData?.ask_your_question}
            </span>

            {!((waitingTime || (!onsessionInfoRef.current && !hasSessionStarted)) && !idealMode) ?
              <div><img src="/vendors/images/microphone-V2.png" alt="" style={{ width: "2.5vw" }} /></div>
              : null
            }

          </button>

          <button
            type="button"
            className="ai_starttalk"
            id="stoprecording"
            style={{
              backgroundColor: disabledState ? 'gray' : siteBrandColor,
              display: aiFormData.enable_rizwan_event === 'yes' ? 'none' : '',
              opacity: disabledState ? 0.7 : 1,
            }}
            onClick={(e) => {
              // Same guard for stop button: block user clicks when disabled, allow programmatic clicks.
              if (disabledState && e?.isTrusted) return;
              disconnect();
            }}
          // disabled={disabledState}
          >
            {currentRecognitionLangListenRef.current
              ? currentRecognitionLangListenRef.current
              : 'Listening...'}
          </button>
          {/* 
          {(rizwanScriptStepRef.current === 1 || rizwanScriptStepRef.current === 2) &&
            aiFormData.enable_rizwan_event === 'yes' &&
            aiFormData?.enable_rizwan_btn === 'yes' && (
              <button
                type="button"
                className="ai_starttalk"
                style={{
                  backgroundColor: siteBrandColor,
                }}
                onClick={() => rizwanButtonFunRun()}
              >
                {rizwanScriptStep === 1
                  ? aiFormData?.enable_rizwan_btn_text_1
                  : aiFormData?.enable_rizwan_btn_text}
              </button>
            )} */}

          <div
            id="textresponse"
            style={{ fontSize: aiFormData.enable_rizwan_event === 'yes' ? '42px' : '20px' }}
          >
            {aiFormData.speech_text_response === 'yes' &&
              (aiFormData.enable_rizwan_event === 'yes' && rizwanScriptStepEnglishRef
                ? currentText
                : aiFormData.enable_rizwan_event === 'yes' && !rizwanScriptStepEnglishRef
                  ? ''
                  : currentRecognitionRef.current)}
          </div>
        </>
      )}
    </div>
  );
};

export default AudioToText;
